Application.Signature = {
    ready: function () {

        this.Name.ready(this.PreviewList);
        this.Icon.ready(this.PreviewList);
        this.Color.ready(this.PreviewList);
        this.LoadingIcon.ready();
        this.Output.ready();
        this.Wallpaper.ready();
        this.WallpaperEditor.ready(this.PreviewList);
        this.LoadingWallpaper.ready();
        this.Contact.ready();
        this.LoadingSignature.ready();
        this.Success.ready();
        this.PreviewList.ready();

    }
}